import React from 'react';
import CuadroHonorDivision from './CuadroHonorDivision.js';
import styles from './PrincipalDivisionPais.module.css';

const PrincipalDivisionPais = (props) => {
  const datosElegidos = props.datosElegidos;

  return (
    <div className={`${styles.base}`}>
      <div className={`${styles.titulo}`}>
        {datosElegidos.division && datosElegidos.division.descripcion}
      </div>
      <div className={`${styles.contenedorCuadros}`}>
        <CuadroHonorDivision
          pais={datosElegidos.pais}
          division={datosElegidos.division}
          categoria={datosElegidos.categoria}
        />
      </div>
    </div>
  );
};

export default PrincipalDivisionPais;
